"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiPeople = function IconUiPeople(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M6.267 15.735a5.033 5.033 0 1 0 5.033-5.063 5.054 5.054 0 0 0-5.033 5.063zm8.066 0a3.033 3.033 0 1 1-3.033-3.063 3.051 3.051 0 0 1 3.033 3.063zm2.536-4.746a6.989 6.989 0 1 0 6.988-7 7 7 0 0 0-6.988 7zm11.977 0a4.989 4.989 0 1 1-4.989-5 5 5 0 0 1 4.989 5z"
  }), _react.default.createElement("path", {
    d: "M13.446 42h20.823v-4.183h9.686v-8.584a7.306 7.306 0 0 0-7.274-7.32 7.189 7.189 0 0 0-4.648 1.687 10.086 10.086 0 0 0-16.257-.131 7.173 7.173 0 0 0-4.476-1.556 7.305 7.305 0 0 0-7.274 7.32v8.584h9.42zm23.235-18.087a5.3 5.3 0 0 1 5.274 5.32v6.584h-7.686v-5.474a11.259 11.259 0 0 0-1.165-5 5.2 5.2 0 0 1 3.577-1.43zm-12.824-2.492a8.688 8.688 0 0 1 8.412 8.922V40H15.446v-9.657a8.688 8.688 0 0 1 8.411-8.922zM6.026 35.817v-6.584a5.3 5.3 0 0 1 5.274-5.32 5.185 5.185 0 0 1 3.384 1.273 11.285 11.285 0 0 0-1.238 5.157v5.474z"
  }), _react.default.createElement("path", {
    d: "M31.647 15.735a5.034 5.034 0 1 0 5.034-5.063 5.055 5.055 0 0 0-5.034 5.063zm8.067 0a3.034 3.034 0 1 1-3.033-3.063 3.051 3.051 0 0 1 3.033 3.063z"
  }));
};

IconUiPeople.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiPeople;
exports.default = _default;